import React from "react";
import { Code } from "@chakra-ui/react";
import { SelectActionWidget } from "./widgets/SelectActionWidget";
import { ConfirmActionWidget } from "./widgets/ConfirmActionWidget";
import { CheckboxesActionWidget } from "./widgets/CheckboxesActionWidget";
import { MappingActionWidget } from "./widgets/MappingActionWidget";
import { InputActionWidget } from "./widgets/InputActionWidget";

export function ChatWidget({ type, config, onSend }) {
  try {
    switch (type) {
      case "select":
        return <SelectActionWidget {...config} onSend={onSend} />;
      case "confirm":
        return <ConfirmActionWidget {...config} onSend={onSend} />;
      case "checkboxes":
        return <CheckboxesActionWidget {...config} onSend={onSend} />;
      case "mapping":
        return <MappingActionWidget {...config} onSend={onSend} />;
      case "input":
        return <InputActionWidget {...config} onSend={onSend} />;
      default:
        return <Code colorScheme="red">Unknown widget type: {type}</Code>;
    }
  } catch {
    return <Code colorScheme="red">Invalid widget config</Code>;
  }
}
